import type { UpgradeDef } from '../../types';

export const SKILL_NAME = 'economy' as const;

export const ECONOMY_UPGRADES: UpgradeDef[] = [
    // =========================================================================
    // ECONOMY BRANCH (Center/Bottom)
    // =========================================================================

    // --- TIER 1 ---
    {
        id: 'eco_begging',
        label: 'Begging',
        icon: 'Coins',
        // Overlap with rock music was 100,700. Now Rock Music is 100,900.
        // Let's safe-move this to 100,1050 or shift X?
        // Let's keep Y high (lower on screen)
        position: { x: 100, y: 1100 },
        description: 'You are poor. Unlocks nothing but pity? No, +1 Market Slot.',
        cost: { gold: 50 },
        effects: [{ type: 'unlock_mechanic', target: 'extra_market_slots', value: 1 }]
    },
    {
        id: 'eco_negotiation_i',
        label: 'Haggling I',
        icon: 'Handshake',
        position: { x: 300, y: 1050 },
        description: 'Market prices 5% better.',
        cost: { gold: 500 },
        prerequisites: ['eco_begging'],
        effects: [{ type: 'market_benefit', value: 0.05 }]
    },
    {
        id: 'eco_inventory_i',
        label: '[WIP] Bigger Pockets',
        icon: 'Backpack',
        position: { x: 300, y: 1150 },
        description: 'Not mechanically implemented yet (stack limits?), but cool.',
        cost: { gold: 500 },
        prerequisites: ['eco_begging'],
        effects: []
    },

    // --- TIER 2 ---
    {
        id: 'eco_negotiation_ii',
        label: 'Haggling II',
        icon: 'Handshake',
        position: { x: 500, y: 650 },
        description: 'Market prices another 10% better.',
        cost: { gold: 2500 },
        prerequisites: ['eco_negotiation_i'],
        effects: [{ type: 'market_benefit', value: 0.10 }]
    },
    {
        id: 'eco_slots_ii',
        label: 'Storefront',
        icon: 'Store',
        position: { x: 500, y: 750 },
        description: '+2 Market Slots.',
        cost: { gold: 3000 },
        prerequisites: ['eco_begging'], // Branch jump or direct?
        effects: [{ type: 'unlock_mechanic', target: 'extra_market_slots', value: 2 }]
    },

    // --- TIER 3 ---
    {
        id: 'eco_insider',
        label: 'Insider Trading',
        icon: 'Briefcase',
        position: { x: 700, y: 700 },
        description: 'Market simulation is rigged in your favor. 20% benefit.',
        cost: { gold: 10000 },
        prerequisites: ['eco_negotiation_ii', 'eco_slots_ii'],
        effects: [{ type: 'market_benefit', value: 0.20 }]
    },
    {
        id: 'eco_monopoly',
        label: 'Monopoly',
        icon: 'Building2',
        position: { x: 900, y: 700 },
        description: 'Unlock ALL market slots.',
        cost: { gold: 50000 },
        prerequisites: ['eco_insider'],
        effects: [{ type: 'unlock_mechanic', target: 'all_market_slots' }]
    },
];
